var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 12,
    r: 2,
    transform: "rotate(-90 5 12)",
    fill: "#181A1B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2,
    transform: "rotate(-90 12 12)",
    fill: "#181A1B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 12,
    r: 2,
    transform: "rotate(-90 19 12)",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotHorizontal);
export default __webpack_public_path__ + "static/media/dotHorizontal.a5c1f8c624b368bc5b3a28f663698564.svg";
export { ForwardRef as ReactComponent };